function getOpt(dataObj) {
  let xData = dataObj.xData;
  let yData1 = dataObj.yData1;
  let yData2 = dataObj.yData2;
  let legend = ["厂区"];
  /*if (bmeConfig.customerSign == 67) {
    legend = ["厂区"]
  } else if (bmeConfig.customerSign == 78 || bmeConfig.customerSign == 92) {
    legend = ['厂区', '国控']
  } else {
    legend = ['厂区', '省控']
  }*/
  let opt_ = {
    backgroundColor: 'transparent',
    tooltip: {
      trigger: 'axis',
      axisPointer: {
        lineStyle: {
          color: '#57617B',
          fontSize: 20
        }
      }
    },
    legend: {
      icon: 'rect',
      itemWidth: 14,
      itemHeight: 5,
      itemGap: 13,
      data: legend,
      right: '4%',
      textStyle: {
        fontSize: 20,
        color: '#fff'
      }
    },
    grid: {
      top: "15%",
      left: '4%',
      right: '10%',
      bottom: '0%',
      containLabel: true
    },
    xAxis: [{
      type: 'category',
      boundaryGap: false,
      axisLine: {
        lineStyle: {
          color: 'rgb(48, 95, 115)'
        }
      },
      axisLabel: { //坐标轴刻度标签的相关设置
        textStyle: {
          color: 'rgba(255,255,255,.5)',
          fontSize: 20,
          margin: 15,
        },
      },
      axisTick: {
        show: false,
      },
      data: xData
    }],
    yAxis: {
      type: 'value',
      //    name: 'μg/m³',
      nameTextStyle: {
        fontSize: 24
      },
      //    max: 100,
      //    min: 0,
      axisTick: {
        show: false
      },
      axisLine: {
        lineStyle: {
          color: 'rgb(48, 95, 115)'
        }
      },
      axisLabel: {
        margin: 10,
        textStyle: {
          color: "rgba(255,255,255,.5)",
          fontSize: 24
        }
      },
      splitLine: {
        lineStyle: {
          color: 'rgba(48, 95, 115,.3)'
        }
      }
    },
    series: [{
      name: '厂区',
      type: 'line',
      smooth: true,
      symbol: 'circle',
      symbolSize: 5,
      showSymbol: false,
      lineStyle: {
        normal: {
          width: 2,
          color: "rgba(62, 234, 236, 1)"
        }
      },
      areaStyle: {
        normal: {
          color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
            offset: 0,
            color: 'rgba(62, 234, 236, 0.2)'
          }, {
            offset: 0.8,
            color: 'rgba(62, 234, 236, 0.05)'
          }], false),
          shadowColor: 'rgba(62, 234, 236, 0)',
          shadowBlur: 10
        }
      },
      itemStyle: {
        normal: {
          color: "rgba(62, 234, 236, 1)",

        }
      },
      data: yData1
    }]
  };
  return opt_
}

export default getOpt;